function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { RiveState, useRive } from '@rive-app/react-canvas';
import { Button, Typography } from 'onboarding-components';
import produce from 'immer';
import { openDemoProjectSelectorModal } from 'common/widgets/demo-selector-modal';
import { SetupGuideContext, Step, SubStep, UserEventPropertiesMapContext, VisibilityContext } from 'common/onboarding/immersive-onboarding-legacy/types';
import { track, TrackingEvent, TrackingProperty } from 'common/onboarding/immersive-onboarding-legacy/tracking';
import { addToast } from 'common/components/toast-area/toast-manager';
import { ToastType } from 'common/components/toast/types';
import { EventSubStepContext } from 'common/onboarding/immersive-onboarding-legacy/steps/events/common';
import { IMMERSIVE_ASSETS } from 'common/onboarding/immersive-onboarding-legacy/assets';
import { ApiClient } from 'common/onboarding/immersive-onboarding-legacy/api-client';
import type { ChromeHeader } from 'common/widgets/chrome/chrome-header';
import { SummaryTable } from 'common/onboarding/immersive-onboarding-legacy/components/';
import { scrollToStep } from 'common/onboarding/immersive-onboarding-legacy/components/scroll-manager';
import { useCurrentUser } from 'common/contexts/react/current-user-context';
import { useTranslation } from 'common/i18n/hooks';
import { useCurrentProject } from 'common/contexts/react/current-project-context';
import { useGlobalSidenavController } from 'common/contexts/react/global-sidenav-controller-context';
import { isGlobalSidenavEnabled } from 'iron/routes/global-sidenav/utils';
import styles from './ready-to-connect-v2.module.styl';
export const ReadyToConnectV2 = _ref => {
  let {
    selected,
    disableNext
  } = _ref;
  const {
    setVisibility
  } = React.useContext(VisibilityContext);
  const currentUser = useCurrentUser().get().value;
  const currentProject = useCurrentProject().get().value;
  const globalSidenavController = useGlobalSidenavController();
  const {
    setSetupGuideInfo,
    setupGuideInfo,
    setStep
  } = React.useContext(SetupGuideContext);
  const {
    currentEventPropertiesMap
  } = React.useContext(UserEventPropertiesMapContext);
  const {
    t
  } = useTranslation();
  const canInviteUsers = Boolean(currentUser);
  const {
    rive,
    RiveComponent
  }: RiveState = useRive({
    src: IMMERSIVE_ASSETS.readyToConnect,
    stateMachines: ["State Machine 1"]
  });
  const {
    eventSubStep
  } = React.useContext(EventSubStepContext);

  // TODO: probably should use IntersectionObserver for this
  React.useEffect(() => {
    let timer;
    if (eventSubStep === SubStep.ReadyToConnect) {
      timer = setTimeout(() => {
        rive.play();
      }, 700);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [eventSubStep]);
  return <div className={styles.container} data-sentry-component="ReadyToConnectV2" data-sentry-source-file="ready-to-connect-v2.tsx">
      <div className={styles.content}>
        <SummaryTable onEdit={() => {
        scrollToStep(SubStep.EventConfirmation);
        track(TrackingEvent.SummaryTableEditClick, {
          [TrackingProperty.Phase2]: true
        });
      }} tableTitle={t("onboarding-legacy.events.planned-events")} data-sentry-element="SummaryTable" data-sentry-source-file="ready-to-connect-v2.tsx" />
        <div className={styles.contentRight}>
          <RiveComponent style={{
          height: "300px",
          width: "300px"
        }} data-sentry-element="RiveComponent" data-sentry-source-file="ready-to-connect-v2.tsx" />
          <div>
            <div className={styles.textContainer}>
              <Typography variant='captionSm' weight='bold' data-sentry-element="Typography" data-sentry-source-file="ready-to-connect-v2.tsx">
                {t("onboarding-legacy.events.teamate-help")}
              </Typography>
              <Typography className={styles.textBody} variant='captionSm' data-sentry-element="Typography" data-sentry-source-file="ready-to-connect-v2.tsx">
                {t("onboarding-legacy.events.send-plan-guide")}
              </Typography>
            </div>
            <div>
              <Button className={styles.buttonPadding} variant='inline' includeArrow={false} size='small' onClick={() => {
              if (canInviteUsers) {
                setVisibility(false);
                if (isGlobalSidenavEnabled(currentProject)) {
                  globalSidenavController.openInviteUserModal({
                    closeCallback: () => setVisibility(true)
                  });
                } else {
                  const chromeHeader = document.querySelector<ChromeHeader>("mp-chrome-header");
                  chromeHeader.helpers.openInviteUserModal(() => setVisibility(true));
                }
              } else {
                addToast({
                  type: ToastType.ERROR,
                  message: t("onboarding.events.missing-invite-access")
                });
              }
              track(TrackingEvent.InviteTeammate, {
                [TrackingProperty.Phase2]: true
              });
            }} data-sentry-element="Button" data-sentry-source-file="ready-to-connect-v2.tsx">
                {t("onboarding-legacy.events.invite-teammate")}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <div>
          <Button disabled={disableNext} size='small' onClick={() => {
          setStep(Step.Implement);
          track(TrackingEvent.SubStepCompleted, {
            [TrackingProperty.SubStepName]: SubStep.ReadyToConnect,
            [TrackingProperty.Phase2]: true
          });
          ApiClient.updateSetupGuideInfo(setupGuideInfo.projectId, selected, null, currentEventPropertiesMap).then(result => {
            setSetupGuideInfo(result);
          });
          const updatedStepsCompleted = produce(setupGuideInfo.stepsCompleted, draft => {
            draft.add(Step.Events);
          });
          ApiClient.updateCompleted(setupGuideInfo.projectId, updatedStepsCompleted);
          setSetupGuideInfo(_objectSpread(_objectSpread({}, setupGuideInfo), {}, {
            stepsCompleted: updatedStepsCompleted
          }));
        }} data-sentry-element="Button" data-sentry-source-file="ready-to-connect-v2.tsx">
            {t("onboarding-legacy.events.connect-data")}
          </Button>
        </div>
        <div>
          <Button variant='inline' size='small' includeArrow={false} onClick={() => {
          track(TrackingEvent.ViewDemoClick, {
            [TrackingProperty.SubStepName]: SubStep.ReadyToConnect,
            [TrackingProperty.Phase2]: true
          });
          openDemoProjectSelectorModal(ev => {
            addToast({
              message: ev.detail.message,
              type: ToastType.ERROR
            });
          }, {
            'is-new-tab': true
          });
        }} data-sentry-element="Button" data-sentry-source-file="ready-to-connect-v2.tsx">
            {t("onboarding-legacy.events.view-demo-project")}
          </Button>
        </div>
      </div>
    </div>;
};